
<template>
  <div class="activate">

    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceIn"
      leave-active-class="animated fadeOut"
    >
      <img src="media/page3/plane.png" v-show="anim1" />
    </transition>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceIn"
      leave-active-class="animated fadeOut"
    >
      <img src="media/page3/green truck.png" v-show="anim2" />
    </transition>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceIn"
      leave-active-class="animated fadeOut"
    >
      <img src="media/page3/boat.png" v-show="anim3" />
    </transition>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceIn"
      leave-active-class="animated fadeOut"
    >
      <img src="media/page3/train.png" v-show="anim4" />
    </transition>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceIn"
      leave-active-class="animated fadeOut"
    >
      <img src="media/page3/green truck.png" v-show="anim5" />
    </transition>


  </div>
</template>

<script>
export default {
  data() {
    return {
      anim1: false,
      anim2: false,
      anim3: false,
      anim4: false,
      anim5: false
    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {
    animate() {
      setTimeout(() => {
        this.anim1 = true
      }, 50);
      setTimeout(() => {
        this.anim[1] = true
      }, 150);
      setTimeout(() => {
        this.anim[2] = true
      }, 250);
      setTimeout(() => {
        this.anim[3] = true
      }, 350);
      setTimeout(() => {
        this.anim[4] = true
      }, 450);
      setTimeout(() => {
        this.anim[0] = false
        this.anim[1] = false
        this.anim[2] = false
        this.anim[3] = false
        this.anim[4] = false
      }, 1500);
    }
  },
  mounted() {
    this.anim1 = true
    setTimeout(() => {
      this.anim2 = true
    }, 50);
    setTimeout(() => {
      this.anim3 = true
    }, 150);
    setTimeout(() => {
      this.anim4 = true
    }, 250);
    setTimeout(() => {
      this.anim5 = true
    }, 350);
    setTimeout(() => {
      this.anim1 = false
      this.anim2 = false
      this.anim3 = false
      this.anim4 = false
      this.anim5 = false
    }, 1500);
    // this.animate()
  },
  beforeDestroy() {

  },
  components: {},
  props: []
};
</script>

<style lang="scss" scoped>
.activate {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
img {
  position: absolute;
  width: 60px;
  top: 49%;
  left: 9%;
  &:nth-child(2) {
    top: 69%;
    left: 25%;
  }
  &:nth-child(3) {
    top: 31%;
    left: 30%;
  }
  &:nth-child(4) {
    top: 51%;
    left: 32%;
  }
  &:nth-child(5) {
    top: 49%;
    left: 50%;
  }
}
@media only screen and (max-width: 750px) {
  img {
    position: absolute;
    width: 40px;
    top: 56%;
    left: 15%;
    &:nth-child(2) {
      top: 86%;
      left: 26%;
    }
    &:nth-child(3) {
      top: 40%;
      left: 27%;
    }
    &:nth-child(4) {
      top: 61%;
      left: 36%;
    }
    &:nth-child(5) {
      top: 60%;
      left: 53%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Animate.vue?6383e8c8